/**
 * CPB: サムネイル（option-type-img）クリックで対応セクションを表示
 * - トップ: .js-topthumblist → 親カテゴリー（切替時は全子セクションを非表示）
 * - 子階層: 各親内サムネ → DOM 上の js-親名 + 数字 クラスを自動検出
 */
(function () {
  'use strict';

  var VISIBLE_CLASS = 'js-section-visible';
  var INIT_FLAG = 'data-cpb-thumb-section-init';
  var STYLE_ID = 'cpb-top-thumb-list-styles';
  var REFRESH_DEBOUNCE_MS = 300;

  var TOP_GROUP = {
    isTop: true,
    thumbListClass: 'js-topthumblist',
    sections: [
      'js-setitem',
      'js-apparel',
      'js-dogtshirts',
      'js-bag',
      'js-accessories',
      'js-embroidery',
    ],
  };

  /** 子セクションを持ちうる親クラス（TOP_GROUP.sections と同じ） */
  var NESTED_PARENTS = TOP_GROUP.sections;

  var refreshTimer = null;

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /**
   * DOM から「親クラス + 数字」形式の子セクションクラスを収集（番号昇順）
   * 例: js-apparel → js-apparel1, js-apparel2, …
   */
  function discoverChildSections(parent) {
    var re = new RegExp('^' + escapeRegExp(parent) + '(\\d+)$');
    var byNum = {};
    var nodes = document.querySelectorAll('.cpb-category');

    nodes.forEach(function (el) {
      el.classList.forEach(function (className) {
        var match = re.exec(className);
        if (!match) return;
        var num = parseInt(match[1], 10);
        if (!isNaN(num)) {
          byNum[num] = className;
        }
      });
    });

    return Object.keys(byNum)
      .map(Number)
      .sort(function (a, b) {
        return a - b;
      })
      .map(function (num) {
        return byNum[num];
      });
  }

  function getAllChildSections() {
    var list = [];
    NESTED_PARENTS.forEach(function (parent) {
      discoverChildSections(parent).forEach(function (c) {
        if (list.indexOf(c) === -1) list.push(c);
      });
    });
    return list;
  }

  function getAllSectionClasses() {
    var list = TOP_GROUP.sections.slice();
    getAllChildSections().forEach(function (c) {
      if (list.indexOf(c) === -1) list.push(c);
    });
    return list;
  }

  function buildStyleText() {
    var all = getAllSectionClasses();
    if (!all.length) return '';

    var hiddenSelectors = all
      .map(function (c) {
        return '.' + c + ':not(.' + VISIBLE_CLASS + ')';
      })
      .join(',');
    var visibleSelectors = all
      .map(function (c) {
        return '.' + c + '.' + VISIBLE_CLASS;
      })
      .join(',');
    return (
      hiddenSelectors +
      '{display:none!important;}' +
      visibleSelectors +
      '{display:block!important;}'
    );
  }

  function refreshStyleSheet() {
    var css = buildStyleText();
    var tag = document.getElementById(STYLE_ID);
    if (!tag) {
      tag = document.createElement('style');
      tag.id = STYLE_ID;
      document.head.appendChild(tag);
    }
    tag.textContent = css;
  }

  function setSectionVisible(el, visible) {
    if (visible) {
      el.classList.add(VISIBLE_CLASS);
      el.removeAttribute('hidden');
      el.setAttribute('aria-hidden', 'false');
      if (el.classList.contains('cpb-category')) {
        el.classList.add('cpb-category-collapse-active');
      }
    } else {
      el.classList.remove(VISIBLE_CLASS);
      el.setAttribute('hidden', '');
      el.setAttribute('aria-hidden', 'true');
    }
  }

  function hideSections(classNames) {
    classNames.forEach(function (className) {
      document.querySelectorAll('.' + className).forEach(function (el) {
        setSectionVisible(el, false);
      });
    });
  }

  function showSection(className) {
    document.querySelectorAll('.' + className).forEach(function (el) {
      setSectionVisible(el, true);
    });
  }

  function ensureVisible(className) {
    document.querySelectorAll('.' + className).forEach(function (el) {
      setSectionVisible(el, true);
    });
  }

  function hideNewChildSections() {
    getAllChildSections().forEach(function (className) {
      document.querySelectorAll('.' + className).forEach(function (el) {
        if (!el.classList.contains(VISIBLE_CLASS)) {
          setSectionVisible(el, false);
        }
      });
    });
  }

  function getNestedThumbIndex(parentEl, optionEl) {
    var container = parentEl.querySelector(
      '.cpb-category-content > .cpb-category-options-container, .cpb-category-content .cpb-category-options-container'
    );
    if (!container || !container.contains(optionEl)) return -1;

    var options = container.querySelectorAll('.option.option-type-img');
    return Array.prototype.indexOf.call(options, optionEl);
  }

  function getTopThumbIndex(thumbList, optionEl) {
    var options = thumbList.querySelectorAll('.option.option-type-img');
    return Array.prototype.indexOf.call(options, optionEl);
  }

  function createNestedGroup(parent) {
    return {
      thumbListClass: parent,
      keepVisibleClass: parent,
      sections: discoverChildSections(parent),
    };
  }

  function handleThumbActivate(group, thumbList, optionEl) {
    var index;
    var sectionClass;
    var childSections;

    if (group.isTop) {
      index = getTopThumbIndex(thumbList, optionEl);
      if (index < 0) return;

      sectionClass = group.sections[index];
      if (!sectionClass) return;

      hideSections(getAllChildSections());
      hideSections(group.sections);
      showSection(sectionClass);
      return;
    }

    index = getNestedThumbIndex(thumbList, optionEl);
    if (index < 0) return;

    childSections = discoverChildSections(group.keepVisibleClass);
    sectionClass = childSections[index];
    if (!sectionClass) return;

    if (group.keepVisibleClass) {
      ensureVisible(group.keepVisibleClass);
    }

    hideSections(childSections);
    showSection(sectionClass);
  }

  function resolveGroup(optionEl) {
    var topList = optionEl.closest('.js-topthumblist');
    if (topList) {
      return { group: TOP_GROUP, thumbList: topList };
    }

    var i;
    var parent;
    var nested;
    for (i = 0; i < NESTED_PARENTS.length; i++) {
      parent = optionEl.closest('.' + NESTED_PARENTS[i]);
      if (parent && getNestedThumbIndex(parent, optionEl) >= 0) {
        return { group: createNestedGroup(NESTED_PARENTS[i]), thumbList: parent };
      }
    }

    return null;
  }

  function onThumbClick(event) {
    var optionEl = event.target.closest('.option.option-type-img');
    if (!optionEl) return;

    var resolved = resolveGroup(optionEl);
    if (!resolved) return;

    handleThumbActivate(resolved.group, resolved.thumbList, optionEl);
  }

  function onOptionActivate(event) {
    var detail = event.detail || {};
    var optionId = detail.optionId || detail.id;
    if (!optionId) return;

    var i;
    var parentClass;
    var parent;
    var container;
    var btn;
    var optionEl;
    var nested;

    for (i = 0; i < NESTED_PARENTS.length; i++) {
      parentClass = NESTED_PARENTS[i];
      parent = document.querySelector(
        '.' + parentClass + '.' + VISIBLE_CLASS
      );
      if (!parent) continue;

      container = parent.querySelector(
        '.cpb-category-content .cpb-category-options-container'
      );
      if (!container) continue;

      btn = container.querySelector('[data-option-id="' + optionId + '"]');
      if (!btn) continue;

      optionEl = btn.closest('.option.option-type-img');
      if (!optionEl) continue;

      nested = createNestedGroup(parentClass);
      handleThumbActivate(nested, parent, optionEl);
      return;
    }
  }

  function initSections() {
    if (document.body.getAttribute(INIT_FLAG)) return;
    if (!document.querySelector('.js-topthumblist')) return;

    hideSections(TOP_GROUP.sections);
    hideSections(getAllChildSections());
    document.body.setAttribute(INIT_FLAG, '1');
  }

  function refreshDiscovery() {
    refreshStyleSheet();
    if (document.body.getAttribute(INIT_FLAG)) {
      hideNewChildSections();
    }
  }

  function scheduleRefresh() {
    if (refreshTimer) window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      refreshDiscovery();
    }, REFRESH_DEBOUNCE_MS);
  }

  function bind() {
    refreshStyleSheet();
    initSections();
    scheduleRefresh();
  }

  document.body.addEventListener('click', onThumbClick);
  document.body.addEventListener('PRODUCT_BUILDER_OPTION_ACTIVATE', onOptionActivate);
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', bind);
  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', scheduleRefresh);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }

  var observer = new MutationObserver(function () {
    if (!document.querySelector('.js-topthumblist')) return;
    scheduleRefresh();
    if (!document.body.getAttribute(INIT_FLAG)) {
      bind();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
